export { default } from "./PlotGraph";
